import React from "react";
import { Footer } from "../GlobalComponent/Footer";
import { Header } from "./Header";
// import { Left } from "./Left";
import { Popup } from "../GlobalComponent/Popup";
import { Preloader } from "../GlobalComponent/Preloader";

type MainLayoutProps = {
	children: React.ReactNode;
};

export const MainLayout = ({ children }: MainLayoutProps) => {
	return (
		<React.Fragment>
			<Preloader></Preloader>
			{/* <Left></Left> */}
			<Popup></Popup>
			<div className="metaportal_fn_main">
				<Header></Header>
				<div className="metaportal_fn_content">
					{children}
					<Footer></Footer>
				</div>
			</div>
		</React.Fragment>


	);
};
